import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";

export const getQueryKey = (orgId?: string) => {
  return ["orgEventMetadataKeys", orgId];
};

export function useEventMetadataKeys(
  orgId?: string,
): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();
  const { currentOrganization } = useAuth();
  const canonicalOrgId = orgId || currentOrganization?.org_id;

  return useQuery({
    queryKey: getQueryKey(canonicalOrgId),
    queryFn: ({ signal }) => {
      return events.getMetadataKeysForOrg({
        abortSignal: signal,
        resourceOwnerId: canonicalOrgId,
      });
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
    enabled: canonicalOrgId !== undefined,
  });
}
